import React, { createContext, useContext, useState, useEffect } from "react";
import {
  setDoc,
  doc,
  collection,
  Timestamp,
  serverTimestamp,
  getDoc,
} from "firebase/firestore";
import {
  createUserWithEmailAndPassword,
  signInWithEmailAndPassword,
  signOut,
  onAuthStateChanged,
  sendPasswordResetEmail,
  signInWithPopup,
  GoogleAuthProvider,
} from "firebase/auth";
import { auth, db, sp } from "../firebase.config";
import { Snackbar } from "@mui/material";

const AuthContext = createContext();

export const AuthContextProvider = ({ children }) => {

  const [user, setUser] = useState({});
  const [event, setCurrentEvent] = useState({});
  const [open, setOpen] = React.useState(false);

  const handleClick = () => {
    setOpen(true);
  };

  const handleClose = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }

    setOpen(false);
  };

  async function signUp(email, password, nom, prenom) {
  try {
    const result = await createUserWithEmailAndPassword(auth, email, password);
    const u = result.user;

    const newCityRef = doc(db, "users", u.uid);
    const newPartnerRef = doc(db, "partners", u.uid);

    await setDoc(newCityRef, {
      dateCreation: serverTimestamp(),
      email: email,
      nom: nom,
      prenom: prenom,
      isPartner: true,
      uid: u.uid,
    });

    await setDoc(newPartnerRef, {
      dateCreation: serverTimestamp(),
      email: email,
      uid: u.uid,
    });

    return u; // ✅ Retourne l'utilisateur en cas de succès
  } catch (error) {
    console.error("Erreur lors de la création du compte :", error);
    throw error; // ✅ Propage l'erreur à l'appelant
  }
}


  async function signUpSecondStep(id) {
    const u = await getDoc(doc(db, "organisateurs", id));
    if (u.exists()) {
      const newCityRef = doc(db, "users", id);
      setDoc(newCityRef, {
        dateCreation: u.data().dateCreation,
        email: u.data().email,
        nom: u.data().nom,
        prenom: u.data().prenom,
        uid: id
      });
    } else {
      logOut()
    }
  }

  function logIn(email, password) {
    return signInWithEmailAndPassword(auth, email, password);
  }

  function logOut() {
    return signOut(auth);
  }

  function forgotPass(email) {
    return sendPasswordResetEmail(auth, email)
  }

  async function handleFacebookSigin() {
    signInWithPopup(auth, sp).then(async (result) => {
      console.log(result)
      const u = result.user
      const u1 = await getDoc(doc(db, "users", u.uid));
      if (!u1.exists()) {
        console.log('creation')
        var tmpName = u.displayName.split(" ")
        console.log(tmpName)
        console.log(tmpName.length)
        await faceSecondStep(u.uid, u.email, tmpName[0], tmpName[tmpName.length - 1], u.photoURL);
      } else {
        const newPartnerRef = doc(db, "partners", u.uid);
        if (u1.data?.isPartner) {
          await setDoc(newPartnerRef, {
            dateCreation: serverTimestamp(),
            email: u.email,
            uid: u.uid,

          });
        }
      }
      return result.user
    }).catch((error) => {
      console.log(error.message)
    })
  }

  const handleGoogleSignIn = async () => {
    const provider = new GoogleAuthProvider();
    signInWithPopup(auth, provider).then(async (result) => {
      console.log(result)
      const u = result.user
      console.log(u)
      const u1 = await getDoc(doc(db, "users", u.uid));
      if (!u1.exists()) {
        console.log('creation')
        var tmpName = u.displayName.split(" ")
        console.log(tmpName)
        console.log(tmpName.length)
        await faceSecondStep(u.uid, u.email, tmpName[0], tmpName[tmpName.length - 1], u.photoURL);
      } else {
        const newPartnerRef = doc(db, "partners", u.uid);
        if (u1.data?.isPartner) {
          await setDoc(newPartnerRef, {
            dateCreation: serverTimestamp(),
            email: u.email,
            uid: u.uid,

          });
        }
      }
      return result.user
    }).catch((error) => {
      console.log(error.message)
    })
  };

  async function faceSecondStep(id, mail, firstname, lastname, photo) {
    try {
      const newCityRef = doc(db, "users", id);
      const newPartnerRef = doc(db, "partners", id);
      await setDoc(newCityRef, {
        dateCreation: serverTimestamp(),
        email: mail,
        nom: lastname,
        prenom: firstname,
        uid: id,
        photoUrl: photo,
        isPartner: true
      });
      await setDoc(newPartnerRef, {
        dateCreation: serverTimestamp(),
        email: mail,
        uid: id,

      });
    } catch (error) {

    }

  }

  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, (currentUser) => {
      setUser(currentUser);
    });
    return () => {
      unsubscribe();
    };
  });

  return (
    <AuthContext.Provider
      value={{ signUp, logIn, logOut, signUpSecondStep, forgotPass, handleFacebookSigin, handleGoogleSignIn, faceSecondStep, user }}
    >
      {children}
    </AuthContext.Provider>
  );
};

export const UserAuth = () => useContext(AuthContext);
